export default "<div class=\"block-header\">\n  <ng-content></ng-content>\n</div>\n"